import { cn } from "@/lib/utils";

interface ToggleProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  /** Disabled but visually full-opacity (e.g. gray “off” integration state) */
  fullOpacityWhenDisabled?: boolean;
}

export function Toggle({
  checked,
  onChange,
  disabled = false,
  className,
  fullOpacityWhenDisabled = false,
}: ToggleProps) {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      className={cn(
        "relative h-5 w-8 shrink-0 rounded-full transition-colors",
        disabled
          ? fullOpacityWhenDisabled
            ? "cursor-not-allowed opacity-100"
            : "cursor-not-allowed opacity-50"
          : "cursor-pointer",
        className
      )}
      style={{
        backgroundColor: checked
          ? "var(--color-toggle)"
          : "var(--color-black-2)",
      }}
    >
      <div
        className={cn(
          "absolute top-[4px] h-[12px] w-[12px] bg-white rounded-full transition-all"
        )}
        style={{
          left: checked ? "16px" : "4px",
        }}
      />
    </button>
  );
}

export default Toggle;
